export default { 
  LIGHTER_BLUE: '#09a4ff',
  LIGHT_BLUE: '#366cc8',
  BLUE: '#204078',
  DARK_BLUE: '#122442',
  WHITE: '#ffffff',
  LIGHT_ORANGE: '#f36868',
  ORANGE: '#f66000',
  DARK_ORANGE: '#ff7319',
  DARK_WHITE: '#fefefe',
  DARKER_WHITE: '#f5f5f5',
  LIGHTEST_GRAY: 'rgba(18, 36, 66, 0.06)',
  LIGHTER_GRAY: 'rgba(18, 36, 66, 0.2)',
  MID_GRAY: 'rgba(18, 36, 66, 0.5)',
  MID_DARK_GRAY: 'rgba(18, 36, 66, 0.6)',
  DARKER_GRAY: 'rgba(18, 36, 66, 0.7)',
  DARKEST_GRAY: 'rgba(18, 36, 66, 0.8)',
  GRAY: 'rgba(199, 207, 221, 0.24)',
  LIGHT_GRAY: 'rgba(141, 141, 141, 0.5)',
  VARIANT_GRAY: 'rgba(112, 112, 112, 0.5)',
  DARK_GRAY: '#8d8d8d',
  GENERIC_GRAY: '#cccccc',
  BLACK: '#272727',
  LIGHT_BLACK: '#101059',
  RED: '#ee3434',
  BLUE_GREEN: "#49d8de",
  EDITOR_TRANSFORMER: "rgb(0, 161, 255)",
  BLUE_HOVER: "#1E3A8A",
  SOFT_GRAY: "#ECEFF1"
}